import { Component, OnInit } from '@angular/core';
import { state, style, transition, animate, trigger } from '@angular/animations';
import { MobileService } from '@service/mobile.service';
import { PartnerService } from '@service/partner.service';
import { environment } from '@environments/environment';
import { Partnerlogo } from '@model/partnerlogo';

@Component({
  selector: 'partner-slider',
  templateUrl: './partner-slider.component.html',
  styleUrls: ['./partner-slider.component.scss'],
  animations: [
    trigger('openClose', [
      state(
        'start',
        style({
          width: '0%',
        }),
      ),
      state(
        'end',
        style({
          width: '100%',
        }),
      ),
      transition('start => end', [animate('10s')]),
      transition('end => start', [animate('0s')]),
    ]),
  ],
})
export class PartnerSliderComponent implements OnInit {
  public environment = environment;

  public sliderItems: Partnerlogo[] = null;

  public selected_index = 0;

  public images_simultaneous: number = 4;

  // autoswitch
  public progressBarValue;
  public intervalTime = 5; // in s
  public secs = 0;
  private interval;

  constructor(
    private MobileService: MobileService,
    private PartnerService: PartnerService,
  ) {}

  ngOnInit() {
    this.PartnerService.getPartnerlogos().then((partnerlogos: Partnerlogo[]) => {
      this.sliderItems = partnerlogos;
      this.selected_index = Math.floor(Math.random() * this.sliderItems.length);
    });

    if (this.MobileService.isMobile) {
      this.images_simultaneous = 1;
    }

    this.MobileService.mobileObservable.subscribe((mobile) => {
      if (mobile) {
        this.images_simultaneous = 1;
      } else {
        this.images_simultaneous = 4;
      }
    });

    this.start_interval();
  }

  public start_interval() {
    this.interval = setInterval(() => {
      this.next();
    }, this.intervalTime * 1000);

    this.secs = 1;
    setInterval(() => {
      this.secs++;
    }, 1000);
  }

  private resetInterval() {
    clearInterval(this.interval);
    this.start_interval();
  }

  public next() {
    if (this.selected_index + 2 > this.sliderItems.length) this.selected_index = 0;
    else this.selected_index++;
    this.secs = 0;
  }

  public previous() {
    this.selected_index--;
    if (this.selected_index < 0) this.selected_index = this.sliderItems.length - 1;

    this.secs = 0;
  }

  public getItem(offset: number = 0) {
    let index = this.selected_index + offset;

    if (index + 1 > this.sliderItems.length) index -= this.sliderItems.length;

    return this.sliderItems[index];
  }
}
